import { Component, For, Show } from "solid-js";
import { Badge, Card } from "../ui";
import { LANDING_PLANS } from "../../content/landing";

const ctaClass =
  "h-9 px-4 text-sm inline-flex items-center justify-center bg-ink text-paper hover:bg-ink-2 rounded font-medium focus-ring";

export const PricingTable: Component = () => {
  return (
    <section id="pricing" aria-labelledby="pricing-heading">
      <h2 id="pricing-heading" class="mb-6">
        Plans and pricing
      </h2>
      <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <For each={LANDING_PLANS}>
          {(plan) => (
            <Card class="p-5 flex flex-col gap-3">
              <div class="flex items-center justify-between gap-2">
                <h3 class="font-medium text-ink">{plan.name}</h3>
                <Show when={plan.badge}>
                  <Badge variant="default">{plan.badge}</Badge>
                </Show>
              </div>
              <div>
                <p
                  data-testid={"price-" + plan.id}
                  class="text-lg font-medium text-ink"
                >
                  {plan.price}
                </p>
                <Show when={plan.priceNote}>
                  <p class="text-sm text-ink-2">{plan.priceNote}</p>
                </Show>
              </div>
              <p class="text-sm text-ink-2">{plan.blurb}</p>
              <ul class="text-sm text-ink-2 flex flex-col gap-1">
                <For each={plan.features}>
                  {(feature) => <li>{feature}</li>}
                </For>
              </ul>
              <a href={plan.cta.href} class={ctaClass}>
                {plan.cta.label}
              </a>
            </Card>
          )}
        </For>
      </div>
    </section>
  );
};
